import {
  AnalyticsParameterConfigSpecRequest,
  RESTAnalyticsParameterValue,
  RESTWarehouseParameter,
} from 'insights/parameters/RESTParameterTypes';
import pickDefined from 'util/pickDefined';

import {restGetValueJsonForConfig} from './ValueGetters';

export function convertRESTToWarehouseParameters(
  parameterConfigs: Array<AnalyticsParameterConfigSpecRequest>,
  parameterValues: Array<RESTAnalyticsParameterValue>
): Array<RESTWarehouseParameter> {
  return parameterConfigs.map((config) => ({
    config: pickDefined(config, 'isMulti', 'systemName', 'type'),
    valueJson: config.id ? restGetValueJsonForConfig(parameterValues, config.id) : null,
  }));
}
